import { IonBreadcrumbs, IonBreadcrumb, IonIcon, IonCard, IonCardContent, IonProgressBar, IonGrid, IonCol, IonRow, IonButton } from '@ionic/react';
import AppContainer from '../AppContainer';
import { chatbubbleEllipses, desktop, rocket, settingsOutline } from 'ionicons/icons';
import Menu from '../components/Menu';
import { useLocation, useHistory } from 'react-router';
import { useContext, useEffect, useState } from 'react';
import GlobalContext from '../domain/GlobalContext';
import { api } from '../domain/ApiService';
import { Artifact, Assistant, Folder, Initiative, KnowledgeBaseItem, Prompt } from '../domain/Types';
import Chat from '../components/Chat';
import { appConfig } from '../domain/Config';
import Prompts from '../components/Prompts';
import Artifacts from '../components/Artifacts';
import React from 'react';

const Page: React.FC = () => {

  const { user, initiative, getInitiative } = useContext(GlobalContext);
  const [ isFetched, setIsFetched ] = useState(false);
  const [ folder, setFolder ] = useState<Folder | null>(null);
  const [ assistant, setAssistant ] = useState<Assistant | null>(null);
  const [ templateAssistant, setTemplateAssistant ] = useState<Assistant | null>(null);
  const [ artifact, setArtifact ] = React.useState<Artifact | null>(null);
  const location = useLocation();
  const history = useHistory();
  const pathSegments = location.pathname.split('/').filter(Boolean);

  let folder_slug = "";
  let assistant_slug = "";
  let settings_slug = false;

  if (pathSegments.length === 2)  {
    
    assistant_slug = pathSegments[1];
  } 
  else {

    folder_slug = pathSegments[1];
    assistant_slug = pathSegments[2];
  }

  useEffect(() => {

    setIsFetched(true);

    if (initiative != null) {

      if (initiative.template && !location.pathname.includes("/settings")) {

        history.push(assistant_slug+ "/settings");
        return;
      }
    
      let template = null;
      if (initiative.template_uid != null)
        template = getInitiative(initiative.template_uid);

      let assistants = initiative.assistants;
      let templateAssistants = null;
      
      if (template != null)
        templateAssistants = template.assistants;

      if (initiative.folders != null) {

        let fConfig = initiative.folders.find((f: Folder) => f.slug === folder_slug);
        let tfConfig = null;

        if (template != null && template.folders != null)
          tfConfig = template.folders.find((f: Folder) => f.slug === folder_slug);

        if (fConfig) {

          setFolder(fConfig);
          if (fConfig != null && fConfig.assistants != null)
            assistants = fConfig.assistants;
          if (tfConfig != null && tfConfig.assistants != null)
            templateAssistants = tfConfig.assistants;
        }
      }

      if (assistants != null) {

        let config = assistants.find((c: Assistant) => c.slug === assistant_slug)
        if (config != null)
          setAssistant(config);
      }

      if (templateAssistants != null) {

        let config = templateAssistants.find((c: Assistant) => c.slug === assistant_slug)
        if (config != null)
          setTemplateAssistant(config);
      }
    }

  }, [initiative, folder_slug, assistant_slug, settings_slug, getInitiative]);

  const getNextAssistant = () => {
    if (
      initiative &&
      initiative.assistants &&
      initiative.assistants.length > 0 &&
      assistant
    ) {
      const currentIndex = initiative.assistants.findIndex(a => a.slug === assistant.slug);
      const nextIndex = currentIndex + 1;
  
      if (nextIndex < initiative.assistants.length) {
        return initiative.assistants[nextIndex];
      }
    }
    return null;
  };
  
  const nextChat = async () => {
    const nextAssistant = getNextAssistant();
  
    if (nextAssistant) {
      history.push("./" + nextAssistant.slug);
    } else {
      history.push("./share");
    }
  };

  const [ artifacts, setArtifacts ] = React.useState<Artifact[]>([]);
  const [ showPrompts, setShowPrompts ] = React.useState<boolean>(false);

  const handleArtifactUpdate = (artifacts: Artifact[]) => {

    if (assistant)
        assistant.artifacts = artifacts;

    setArtifacts(artifacts);

    if (!artifacts || artifacts.length === 0)
      setShowPrompts(true);
    else
      setShowPrompts(false);
  }
  
  const updateInitiative = async () => {

    if (initiative != null) {

      try { 

        await api("/initiative/update", initiative, initiative) as Initiative; 
        window.dispatchEvent(new Event('initiativeUpdated'));
      }
      catch (err) { console.error('Error:', err); }
    }
  }
  
  const addToKnowledgeBase = (item: string | null, target: string | null, ) => {

    if (target === null)
      target = "assistant";

    console.log("addToKnowledgeBase: "+ item +", "+ target);
    
    if (assistant != null && folder != null && initiative != null && item != null) {      

      setIsFetched(false);
      let kBase = assistant.knowledge_base
      if (target === "folder")
         kBase = folder?.knowledge_base;
      else if (target === "initiative")
         kBase = initiative?.knowledge_base;

      if (!kBase || kBase === null)
          kBase = [];

      let kBaseItem = { "content": item, "source_assistant_uid": assistant?.uid } as KnowledgeBaseItem;
      kBase.push(kBaseItem);

      if (target === "folder")
         folder.knowledge_base = kBase;
      else if (target === "initiative")
         initiative.knowledge_base = kBase;
      else
         assistant.knowledge_base = kBase;

      updateInitiative();
    }

    setIsFetched(true);
  }

  const saveKnowledgeBase = (items: KnowledgeBaseItem[]) => {

    if (assistant != null) {

      setIsFetched(false);
      assistant.knowledge_base = items;
      updateInitiative();
      setIsFetched(true);
    }
  };

  const [defaultMessage, setDefaultMessage] = React.useState('');
  const handlePromptClick = (item: Prompt | null) => {

    setDefaultMessage("");
    
    if (item) {

      const randomSpaces = ' '.repeat(Math.floor(Math.random() * 11));
      const messageWithSpaces = `${item?.content} ${randomSpaces}`;
      setDefaultMessage(messageWithSpaces);
    }
  }

  const handleArtifactGenerate = () => {
    
    if (artifacts == null || artifacts.length == 0) {

      if (assistant?.artifact_type != 1) {

          setDefaultMessage("Draft "+ assistant?.name.toLowerCase() +" based on current knowledge. Produce as new artifacts.");
      }
      else {

          setDefaultMessage("Draft "+ assistant?.name.toLowerCase() +" based on current knowledge. Produce as an artifact.");
      }
      }
    else {

      if (assistant?.artifact_type != 1) {

          setDefaultMessage("Draft more "+ assistant?.name.toLowerCase() +" based on current knowledge. Produce as new artifacts.");
      }
      else {

          setDefaultMessage("Rewrite "+ assistant?.name.toLowerCase() +" based on current knowledge. Produce as an artifact.");
      }
    }
  }

  const handleArtifactRedo = (item: Artifact | null) => {

    if (item) {

      setArtifact(item);
    }
  }

  return (
    <>
      {(isFetched && initiative != null && initiative.initiative_type != null) ? (
        <>          
          <IonGrid>
            <IonRow>
              <IonCol>
                <IonCard className='filled' style={{ padding: "5px" }}>
                  <IonCardContent style={{ height: "85vh" }}>
                    {(assistant != null) ? (
                    <Chat 
                        assistant={assistant} 
                        defaultAssistantId={ (appConfig.initiativeAssistants as any)[initiative.initiative_type] }
                        addToKnowledgeBase={addToKnowledgeBase}
                        defaultMessage={defaultMessage}
                        artifact={artifact}
                        setArtifact={setArtifact}
                        showPrompts={false}
                    />
                    ) : ( <></> )}
                  </IonCardContent>
                </IonCard>

              </IonCol>
              <IonCol size="6">

                <IonCard className='filled' style={{ padding: "5px" }}>
                  <IonCardContent style={{ height: "85vh" }}>
                  <div className="side-container">
                    <div className="side-container-content">
                      {showPrompts ? (
                        <>
                          <Prompts assistant_uid={!assistant?.uid ? "-" : assistant.uid} showHeader={false} showActions={false} handleClick={handlePromptClick} />
                          <Prompts assistant_uid={!templateAssistant?.uid ? "-" : templateAssistant.uid} showHeader={false} showActions={false} handleClick={handlePromptClick} />
                        </>
                      ) : (<></>)}
                      <Artifacts assistant={assistant} handleRedo={handleArtifactRedo} onUpdate={handleArtifactUpdate} />
                    </div>
                    <div className="side-container-actions">
                      <IonButton className={ artifacts.length == 0 ? "" : "basic" } onClick={handleArtifactGenerate}>{ artifacts.length > 0 ? (assistant?.artifact_type != 1 ? "Draft more" : "Rewrite") : "Draft" }: {assistant?.name}</IonButton>
                      <IonButton className={ artifacts.length > 0 ? "" : "basic" } onClick={nextChat}>
                        Next: {getNextAssistant() != null ? getNextAssistant()?.name : initiative.deliverable}
                      </IonButton>
                    </div>
                  </div>
                  </IonCardContent>
                </IonCard>

              </IonCol>
            </IonRow>
          </IonGrid>
        </>

      ) : (

        <IonProgressBar type="indeterminate" color="medium"></IonProgressBar>

      )}
    </>
  );
};

const Breadcrumb: React.FC = () => {

    const { user, initiative } = useContext(GlobalContext);
    const location = useLocation();
    const pathSegments = location.pathname.split('/').filter(Boolean);

    let assistant = null;
    let folder_slug = "";
    let assistant_slug = "";
    let settings_slug = false;
  
    if (pathSegments.length === 2)  {
      
      assistant_slug = pathSegments[1];
    } 
    else if(pathSegments[2] === "settings") {
  
      assistant_slug = pathSegments[1];
      settings_slug = true;
    }
    else {
  
      folder_slug = pathSegments[1];
      assistant_slug = pathSegments[2];
    }

    if (initiative?.assistants != null) {

      assistant = initiative.assistants.find((c: Assistant) => c.slug === assistant_slug)
    }

    return (
      <IonBreadcrumbs>
        <IonBreadcrumb routerLink={"/"}>
          <IonIcon slot="start" icon={rocket}></IonIcon>
          Base
        </IonBreadcrumb>
        <IonBreadcrumb routerLink={"../"+ initiative?.slug}>
          <IonIcon slot="start" icon={desktop}></IonIcon>
          {initiative?.name}
        </IonBreadcrumb>
        <IonBreadcrumb>
          <IonIcon slot="start" icon={chatbubbleEllipses}></IonIcon>
          {assistant?.name}
        </IonBreadcrumb>
        { user?.account?.plan == "creator" || user?.account?.plan == "business" && 
        <IonBreadcrumb routerLink={"./"+ assistant_slug +"/settings"}>
          <IonIcon slot="end" icon={settingsOutline}></IonIcon>
        </IonBreadcrumb>
        }
      </IonBreadcrumbs>   
    );
  };
  
const Container: React.FC<{}> = () => { return <AppContainer ContentComponent={Page} BreadcrumbComponent={Breadcrumb} MenuComponent={Menu} />; };
export default Container;